import React, {useEffect, useState} from "react";
import IbatApi from "../../utils/IbatApi";
import {IconButton} from "@mui/material";

export default function CustomImage({className,width,height,name,layerName,onClick,onRightClick, style, url, downloadable, imgClassName, ibatApi}){
    const api= ibatApi ?? new IbatApi()
    const [image,setImage]=useState()
    const [canvas,setCanvas]=useState()

    useEffect(()=>{
        if (!layerName){
            return
        }
        layerSuperposition().then(b64=>setCanvas(b64))

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[layerName])

    useEffect(()=>{
        if (url) {
            setImage(url)
            return
        }
        if (name){
            api.getFile(name).then(img=>setImage(img.url))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[name, url])

    function handleRightClick(e) {
        e.preventDefault()
        onRightClick&&onRightClick()
    }

    function loadImg(img, ctx,cnvas) {
        return new Promise ( resolve=>{
            let bkGround = new Image();
            api.getFile(img).then(file=>bkGround.src=file.url);
            bkGround.onload = ()=>{
                cnvas.height = bkGround.height
                cnvas.width = bkGround.width
                ctx.drawImage(bkGround, 0, 0);
                resolve(ctx)
            }
        })
    }

    function draw(ctx,img,cnvas) {
        return new Promise(resolve => {
            const icon = new Image()
            api.getFile(img).then(file => icon.src = file.url);
            icon.onload = () => {
                // cnvas.height = icon.height
                // cnvas.width = icon.width
                ctx.drawImage(icon, 0 ,0,cnvas.width,cnvas.height)
                resolve(ctx)
            }
        })
    }

    function layerSuperposition(){
        let canvs = document.createElement('canvas');
        const ctx = canvs.getContext('2d');
        return loadImg(name,ctx,canvs)
            .then(ctx=> draw(ctx,layerName,canvs))
            .then(()=>canvs.toDataURL())
    }


    return(
        <div className={className}>
            <img className={imgClassName} alt={"file"} style={style} onContextMenu={handleRightClick} onClick={onClick} width={width} height={height} src={layerName?canvas:image}/>
            { downloadable &&
                <IconButton className={"action-btn validation"}>
                <a download href={layerName?canvas:image}>Télécharger</a>
            </IconButton>
            }
        </div>
    )
}

